import { APP_ENDPOINTS } from "./AppEndpoints";

export const NAV_LINKS = [
	{ id: 2, title: "About", path: APP_ENDPOINTS.ABOUT },
	{ id: 3, title: "Services", path: APP_ENDPOINTS.SERVICES },
	{ id: 4, title: "Expertise", path: APP_ENDPOINTS.EXPERTISE },
	{ id: 5, title: "Freelancers", path: APP_ENDPOINTS.FREELANCERS },
	{ id: 6, title: "Contact Us", path: APP_ENDPOINTS.CONTACT_US },
];
